document.addEventListener('DOMContentLoaded', function () {

    if (typeof wp !== 'undefined' && wp.domReady) {
        wp.domReady(function () {
            setTimeout(function () {
                splide()
            }, 500); // Delay after the DOM is ready
        });
    } else {
        splide()
    }

    function splide() {
        const splideElements = document.querySelectorAll('.reviews-section .splide');
        if (splideElements.length) {
            splideElements.forEach((element) => {
                const splide = new Splide(element, {
                    type: 'fade',
                    rewind: true,
                    rewindSpeed: 2000,
                    slidesToScroll: 1,
                    autoplay: true,
                    interval: 3000, // correct Splide option
                    arrows: true,
                    pagination: true, // not 'dots' in Splide.js
                    speed: 800, // smooth transition speed (in ms)
                    easing: 'ease',
                });
                splide.mount();
            });
        }
    }


});

